import {InjectionToken} from '@angular/core';

/**
 * Configuration du module
 *
 * @author Laurent Convert
 * @date 11/08/2025
 */

/** énumération des différents types de handler */
export enum TypeHandler {
	WEBSOCKET = "websocket",
	POLLING = "polling",
}

/** Token pour configurer globalement le mode par défaut */
export const DEFAULT_PROGRESS_HANDLER_TYPE = new InjectionToken<TypeHandler>('TypeHandler');